export default __webpack_public_path__ + "static/media/powerline_icon.d62a1976.svg";